@if (pageReady) {
    <div class="detail-page-action-bar">
        <button class="btn btn-raised" (click)="save()">
            <i class="fas fa-save" aria-hidden="true"></i>
            <span class="d-none d-lg-inline ms-2">{{ "periodicDetail.saveButton" | t }}</span>
        </button>
        @if (id !== "0") {
            <button class="btn btn-raised red" (click)="deleteClick()">
                <i class="fas fa-trash"></i>
                <span>{{ "periodicDetail.deleteButton" | t }}</span>
            </button>
        }
    </div>

    <div class="detail-page-card" [formGroup]="incidentForm">
        <div class="detail-page-card-title">
            {{ "periodicDetail.editPeriodicTitle" | t }}
        </div>
        <div class="detail-page-card-body padded form-group-styling invite-compose-area">
            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'periodicDetail.nameLabel' | t"
                    formControlName="name"
                    name="notification-name"
                    dataUiid="periodic-detail-incidents-name"
                    [required]="true"
                    [placeholder]="'periodicDetail.requiredPlaceholder' | t"
                ></cerrix-textfield>
            </div>
            <div class="form-group">
                <cerrix-checkbox
                    fontsize="0.9em"
                    [label]="'periodicDetail.activeLabel' | t"
                    data-uiid="periodic-detail-incidents-active"
                    formControlName="active"
                ></cerrix-checkbox>
            </div>
            <div class="form-group">
                <label>{{ "periodicDetail.periodLabel" | t }}</label>
                <ng-select
                    id="periodSelect"
                    name="periodSelect"
                    [items]="periods"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="false"
                    formControlName="period"
                    [placeholder]="'periodicDetail.requiredPlaceholder' | t"
                    (change)="setDayNumbers($event)"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "periodicDetail.dayLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.dayTooltip' | t"
                        matTooltipClass="breakable-tooltip"
                    ></i>
                </label>
                <ng-select
                    id="dayNumberSelect"
                    name="dayNumberSelect"
                    [items]="dayNumbers"
                    [readonly]="!notification.period"
                    bindLabel="Name"
                    bindValue="ID"
                    [multiple]="false"
                    formControlName="dayNumber"
                    [placeholder]="'periodicDetail.requiredPlaceholder' | t"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "periodicDetail.incidentStatusLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.incidentStatusTooltip' | t"
                    ></i>
                </label>
                <ng-select
                    id="incidentStatuses"
                    name="incidentStatusSelect"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [items]="incidentStatuses"
                    bindLabel="Name"
                    bindValue="ID"
                    formControlName="incidentStatuses"
                    [placeholder]="'periodicDetail.allPlaceholder' | t"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "periodicDetail.userRolesLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.userRolesTooltip' | t"
                    ></i>
                </label>
                <ng-select
                    id="userRoleIDs"
                    name="userRolesSelect"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [items]="userRoles"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="userRoleIDs"
                    [placeholder]="'periodicDetail.allPlaceholder' | t"
                ></ng-select>
            </div>
            <div class="form-group">
                <label>
                    {{ "periodicDetail.organizationLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.organizationTooltip' | t"
                    ></i>
                </label>
                <cerrix-select-tree
                    class="fullWidth"
                    [getDataMethod]="organizationRequest"
                    formControlName="organizations"
                    [multiselect]="true"
                ></cerrix-select-tree>
            </div>

            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'periodicDetail.messageLabel' | t"
                    formControlName="subject"
                    name="notification-subject"
                    dataUiid="periodic-detail-incidents-subject"
                    [required]="true"
                    [placeholder]="'periodicDetail.requiredPlaceholder' | t"
                    (click)="setFocusToSubject()"
                ></cerrix-textfield>
                @for (keyword of keywords; track keyword) {
                    <button class="keyword-button" (click)="addKeyword(keyword)">
                        {{ keyword }}
                    </button>
                }
                <cerrix-editor
                    [class.cerrixEditor]="isEmpty"
                    [value]="notification.message"
                    [allowPdfEmbed]="false"
                    (valueChange)="onChangeMessage($event)"
                    (click)="deFocusSubject()"
                    #incidenteditor
                ></cerrix-editor>
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
